/**
 *
 */
interface PasswordSecurityInterface {
    willPasswordExpireSoon: boolean | null, hasPasswordExpired: boolean | null, daysRemainedForPasswordExpiry: number | null, isMfaEnabled: boolean | null,
    passwordExpiryDate: string | null, mfaEnableLastDate: string | null
}
/**
 *
 */
const passwordSecurityDefaultData: PasswordSecurityInterface = { willPasswordExpireSoon: null, hasPasswordExpired: null, daysRemainedForPasswordExpiry: null, isMfaEnabled: null, passwordExpiryDate: null, mfaEnableLastDate: null }
/**
 *
 */
type PasswordSecurityReducerState = { data: PasswordSecurityInterface, isLoading: boolean, error: string }
type PasswordSecurityReducerAction = { type: 'SET_DATA', payload: PasswordSecurityInterface } | { type: 'SET_LOADING', payload: boolean } | { type: 'SET_ERROR', payload: string } | { type: 'RESET' }
/**
 *
 */
const passwordSecurityReducer = (state: PasswordSecurityReducerState, action: PasswordSecurityReducerAction): PasswordSecurityReducerState => {
    switch (action.type) {
            case 'SET_DATA':
                return { ...state, data: action.payload }
            case 'SET_LOADING':
                if (action.payload === true) return { ...state, isLoading: true, data: passwordSecurityDefaultData, error: '' }
                return { ...state, isLoading: false }
            case 'SET_ERROR':
                return { ...state, error: action.payload }
            case 'RESET':
                return { data: passwordSecurityDefaultData, isLoading: false, error: '' }
            default:
                return state
    }
}

/**
 *
 */
type DeviceInterface = {
    id: number
    name: string
    currentDevice?: boolean
    location: string
    date: string
    type: 'Desktop' | 'Mobile'
}
/**
 *
 */
const deviceDefaultData: DeviceInterface[] = []
/**
 *
 */
type DeviceReducerState = { data: DeviceInterface[], isLoading: boolean, error: string }
type DeviceReducerAction = { type: 'SET_DATA', payload: DeviceInterface[] } | { type: 'SET_LOADING', payload: boolean } | { type: 'SET_ERROR', payload: string } | { type: 'RESET' }
/**
 *
 */
const deviceReducer = (state: DeviceReducerState, action: DeviceReducerAction): DeviceReducerState => {
    switch (action.type) {
            case 'SET_DATA':
                return { ...state, data: action.payload }
            case 'SET_LOADING':
                if (action.payload === true) return { ...state, isLoading: true, data: deviceDefaultData, error: '' }
                return { ...state, isLoading: false }
            case 'SET_ERROR':
                return { ...state, error: action.payload }
            case 'RESET':
                return { data: deviceDefaultData, isLoading: false, error: '' }
            default:
                return state
    }
}

/**
 *
 */
const clearSessionsDefaultData = null
/**
 *
 */
type ClearSessionsReducerState = { data: any, isLoading: boolean, error: string }
type ClearSessionsReducerAction = { type: 'SET_DATA', payload: any } | { type: 'SET_LOADING', payload: boolean } | { type: 'SET_ERROR', payload: string } | { type: 'RESET' }
/**
 *
 */
const clearSessionsReducer = (state: ClearSessionsReducerState, action: ClearSessionsReducerAction): ClearSessionsReducerState => {
    switch (action.type) {
            case 'SET_DATA':
                return { ...state, data: action.payload }
            case 'SET_LOADING':
                if (action.payload === true) return { ...state, isLoading: true, data: clearSessionsDefaultData, error: '' }
                return { ...state, isLoading: false }
            case 'SET_ERROR':
                return { ...state, error: action.payload }
            case 'RESET':
                return { data: clearSessionsDefaultData, isLoading: false, error: '' }
            default:
                return state
    }
}

/**
 *
 */
export { PasswordSecurityInterface, passwordSecurityDefaultData, PasswordSecurityReducerState, passwordSecurityReducer, deviceDefaultData, DeviceReducerState, deviceReducer, ClearSessionsReducerState, clearSessionsReducer, clearSessionsDefaultData }
